import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGlobalStore } from '@digiwedge/global-state';
import { Login } from '@digiwedge/ui-antd';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

export default function LoginRedirect() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = useGlobalStore((s) => s.token);
  let redirectTo = params.get('redirectTo') || '';
  if (!redirectTo) {
    try {
      redirectTo = localStorage.getItem('cmp.portal.lastRoute') || '';
    } catch {
      redirectTo = '';
    }
  }
  if (!redirectTo) redirectTo = '/sites';

  useEffect(() => {
    if (token) nav(redirectTo, { replace: true });
  }, [token, redirectTo, nav]);

  return (
    <div>
      {/* Fixed back-to-home button, visible while unauthenticated */}
      {!token && (
        <div
          style={{
            position: 'fixed',
            top: 16,
            left: 16,
            zIndex: 1000,
          }}
        >
          <Button onClick={() => nav('/home')} icon={<ArrowLeftOutlined />}>
            Back to Home
          </Button>
        </div>
      )}

      {/* Centered login experience from the shared UI library */}
      <Login appName="CMP Portal" />
    </div>
  );
}
